const MessagesIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.3133 11.2207L12.5733 13.3273C12.6399 13.8807 12.0466 14.2673 11.5733 13.9807L9.2666 12.6073C9.1066 12.514 9.0666 12.314 9.15326 12.154C9.4866 11.5407 9.6666 10.8473 9.6666 10.154C9.6666 7.71398 7.57326 5.72732 4.99993 5.72732C4.47326 5.72732 3.95993 5.80732 3.47993 5.96732C3.23326 6.04732 2.99326 5.82065 3.05326 5.56732C3.65993 3.14065 5.99326 1.33398 8.77993 1.33398C12.0333 1.33398 14.6666 3.79398 14.6666 6.82732C14.6666 8.62732 13.7399 10.2207 12.3133 11.2207Z"
      fill="currentColor"
    />
    <path
      d="M8.66634 10.1532C8.66634 10.9466 8.37301 11.6799 7.87967 12.2599C7.21967 13.0599 6.17301 13.5732 4.99967 13.5732L3.25967 14.6066C2.96634 14.7866 2.59301 14.5399 2.63301 14.1999L2.79967 12.8866C1.90634 12.2666 1.33301 11.2732 1.33301 10.1532C1.33301 8.9799 1.95967 7.94656 2.91967 7.33323C3.51301 6.94656 4.22634 6.72656 4.99967 6.72656C7.02634 6.72656 8.66634 8.2599 8.66634 10.1532Z"
      fill="currentColor"
    />
  </svg>
);

export default MessagesIcon;
